(function (w, doc, undefined) {
	'use strict';

	let ARIAtabs = {};
	w.ARIAtabs = ARIAtabs;

	let widgetClass = 'rs-tabs';
	let widgetTabListClass = widgetClass + '__list';
	let widgetTriggerClass = widgetClass + '__trigger';
	let widgetPanelClass = widgetClass + '__panel';

	let widgetHeading = '[data-aria-tabs-heading]';
	let widgetPanel = '[data-aria-tabs-panel]';

	let idCounter = 0;

	let keys = {
		end: 35,
		home: 36,
		left: 37,
		up: 38,
		right: 39,
		down: 40,
		delete: 46,
		enter: 13,
		space: 32
	};

	let direction = {
		37: -1,
		38: -1,
		39: 1,
		40: 1
	};

	/**
	 * Create object.
	 */
	ARIAtabs.create = function () {
		let self;
		let panels;
		let headings;
		let triggers;
		let vertical;
		let defaultTab;
		let i;

		let widget = doc.querySelectorAll('[data-component="data-aria-tabs"]');

		idCounter += 1;

		for (i = 0; i < widget.length; i++) {
			self = widget[i];
			let t;

			// Setup tabs component ID
			if (!self.hasAttribute('id')) {
				self.id = 'tab_' + idCounter + '-' + i;
			}

			// Add tabs component class
			self.classList.add(widgetClass);

			// Add orientation class
			vertical = self.getAttribute('aria-orientation') === 'vertical';
			if (vertical) {
				self.classList.add(widgetClass + '--vertical');
			} else {
				self.classList.add(widgetClass + '--horizontal');
			}

			// Determine default tab/panel to display
			if (self.hasAttribute('data-default')) {
				defaultTab = self.getAttribute('data-default');
			} else {
				defaultTab = 1;
			}

			// Get existing panels & headings
			panels = doc.querySelectorAll('#' + self.id + ' ' + widgetPanel);
			headings = doc.querySelectorAll('#' + self.id + ' ' + widgetHeading);

			// Setup panels & tabs.
			ARIAtabs.setupPanels(self.id, panels, defaultTab);
			ARIAtabs.setupTabList(self.id, headings, defaultTab);

			// Get newly defined triggers
			triggers = doc.querySelectorAll('#' + self.id + ' .' + widgetTriggerClass);

			// Setup triggers functionality
			for (t = 0; t < triggers.length; t++) {
				triggers[t].addEventListener('click', ARIAtabs.clickEventListener);
				triggers[t].addEventListener('keydown', ARIAtabs.keydownEventListener);
				triggers[t].addEventListener('keyup', ARIAtabs.keyupEventListener);
			}
		} // for(widget.length)
	}; // ARIAtabs.create()

	/**
	 * Setup tabs panels.
	 */
	ARIAtabs.setupPanels = function (id, panels, defaultTab) {
		let i;
		let panel;
		let panelID;

		for (i = 0; i < panels.length; i++) {
			panel = panels[i];

			// Add panel id
			panelID = id + '_panel_' + (i + 1);
			panel.setAttribute('id', panelID);

			// Add panel class
			panel.classList.add(widgetPanelClass);

			// Add aria role
			panel.setAttribute('role', 'tabpanel');

			// Add aria-labelledby
			panel.setAttribute('aria-labelledby', panelID + "_trigger");

			// Remove tab index
			panel.tabIndex = 0;

			// Un-hide default panel
			panel.hidden = i !== defaultTab - 1;

		}
	}; // ARIAtabs.setupPanels

	/**
	 * Setup tabs list.
	 */
	ARIAtabs.setupTabList = function (id, headings, defaultTab) {
		let i;
		let heading;
		let oldList;
		let oldItems;
		let newList;
		let newItem;
		let newButton;
		let self;

		// Check if existing tabs list specified
		oldList = doc.querySelector('#' + id + ' [data-aria-tabs-list]');

		if (oldList) {

			// Add list class
			oldList.classList.add(widgetTabListClass);

			// Add aria role
			oldList.setAttribute('role', 'tablist');
			oldItems = oldList.getElementsByTagName("li");

			for (i = 0; i < oldItems.length; ++i) {
				heading = headings[i];

				// Add aria role
				oldItems[i].setAttribute('role', 'presentation');

				// remove child link
				oldItems[i].innerHTML='';

				// Create new button
				newButton = createButton(i, id, heading.textContent);
				oldItems[i].appendChild(newButton);
			}
		} else {

			// Create new list
			newList = doc.createElement('ul');

			// Add list class
			newList.classList.add(widgetTabListClass);

			// Add aria role
			newList.setAttribute('role', 'tablist');

			// Re-add indicator for completeness
			newList.setAttribute('data-aria-tabs-list', '');

			for (i = 0; i < headings.length; i++) {
				heading = headings[i];

				// Create new list item and aria role
				newItem = doc.createElement('li');
				newItem.setAttribute('role', 'presentation');

				// Create new button
				newButton = createButton(i, id, heading.textContent);

				// Add item and button
				newItem.appendChild(newButton);
				newList.appendChild(newItem);
			}

			// Insert new tabs list at start of widget
			self = doc.querySelector('#' + id);
			self.prepend(newList);
		}

		function createButton (i, id, text) {
			let button;
			let buttonID = id + '_panel_' + (i + 1);
			let buttonText = text;

			// Create new button
			button = doc.createElement('button');

			// Add the heading text
			button.appendChild(doc.createTextNode(buttonText));

			// Add button id
			button.setAttribute('id', buttonID + '_trigger');

			// Add button class
			button.classList.add(widgetTriggerClass);

			// Add aria role
			button.setAttribute('role', 'tab');

			// Add aria-labelledby
			button.setAttribute('aria-controls', buttonID);

			// Re-add indicator for completeness
			button.setAttribute('data-aria-tabs-heading', '');

			// Remove all but default tab from default navigations flow
			if (i !== defaultTab - 1) {
				button.tabIndex = -1;
			}

			// Set aria-selected for default tab
			if (i === defaultTab - 1) {
				button.setAttribute('aria-selected', 'true');
			} else {
				button.setAttribute('aria-selected', 'false');
			}

			return button;
		}

	}; // ARIAtabs.setupTabList

	/**
	 * Handle click event.
	 */
	ARIAtabs.clickEventListener = function (event) {
		let tab = event.target;

		// Get ID for this tabs component
		let thisTabsID = this.id.replace(/_panel.*$/g, '');

		// Get all related triggers and panels
		let thisTriggers = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetTriggerClass);
		let thisPanels = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetPanelClass);

		ARIAtabs.activateTab(tab, true, thisTriggers, thisPanels);
	}; // ARIAtabs.clickEventListener

	/**
	 * Handle keydown event.
	 */
	ARIAtabs.keydownEventListener = function (event) {
		let key = event.keyCode;

		// Get ID for this tabs component
		let thisTabsID = this.id.replace(/_panel.*$/g, '');

		// Get all related triggers and panels
		let thisTriggers = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetTriggerClass);
		let thisPanels = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetPanelClass);

		switch (key) {
			case keys.end:
				event.preventDefault();
				// Activate last tab
				ARIAtabs.activateTab(thisTriggers[thisTriggers.length - 1], true, thisTriggers, thisPanels);
				break;
			case keys.home:
				event.preventDefault();
				// Activate first tab
				ARIAtabs.activateTab(thisTriggers[0], true, thisTriggers, thisPanels);
				break;

			case keys.up:
			case keys.down:
				ARIAtabs.determineOrientation(event, thisTabsID, thisTriggers, thisPanels);
				break;
		}
	}; // ARIAtabs.keydownEventListener

	/**
	 * Handle keyup event.
	 */
	ARIAtabs.keyupEventListener = function (event) {
		let key = event.keyCode;

		// Get ID for this tabs component
		let thisTabsID = this.id.replace(/_panel.*$/g, '');

		// Get all related triggers and panels
		let thisTriggers = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetTriggerClass);
		let thisPanels = doc.querySelectorAll('#' + thisTabsID + ' .' + widgetPanelClass);

		switch (key) {
			case keys.left:
			case keys.right:
				ARIAtabs.determineOrientation(event, thisTabsID, thisTriggers, thisPanels);
				break;
		}
	}; // ARIAtabs.keyupEventListener

	/**
	 * Determine whether horizontal or vertical tabs component.
	 */
	ARIAtabs.determineOrientation = function (event, thisTabsID, thisTriggers, thisPanels) {
		let key = event.keyCode;

		let thisTabs = doc.getElementById(thisTabsID);
		let vertical = thisTabs.getAttribute('aria-orientation') === 'vertical';
		let stackWidth = thisTabs.getAttribute('data-aria-tabs-stack-below');
		let currentWidth = w.innerWidth;
		let proceed = false;

		if (vertical || (currentWidth < stackWidth)) {
			// Up and down only allowed on vertical tabs
			if (key === keys.up || key === keys.down) {
				event.preventDefault();
				proceed = true;
			}
		} else {
			// Left and right only allowed on horizontal tabs
			if (key === keys.left || key === keys.right) {
				proceed = true;
			}
		}

		if (proceed) {
			ARIAtabs.switchTabOnArrowPress(event, thisTriggers, thisPanels);
		}
	}; // ARIAtabs.determineOrientation

	/**
	 * Handle switching tabs based on arrow keys pressed.
	 */
	ARIAtabs.switchTabOnArrowPress = function (event, thisTriggers, thisPanels) {
		let pressed = event.keyCode;

		if (direction[pressed]) {
			let target = event.target;
			let targetID = target.getAttribute('id');

			let currentIndex;
			let targetIndex;

			// Get position of target in triggers array
			thisTriggers.forEach((nodes, index) => {
				if (nodes.id.indexOf(targetID) !== -1) {
					currentIndex = index;
				}
			});

			targetIndex = currentIndex + direction[pressed];

			if (targetIndex !== undefined) {
				if (thisTriggers[targetIndex]) {
					// Active next or previous tab (if exists)
					ARIAtabs.activateTab(thisTriggers[targetIndex], true, thisTriggers, thisPanels);
				} else if (pressed === keys.left || pressed === keys.up) {
					// Activate last tab
					ARIAtabs.activateTab(thisTriggers[thisTriggers.length - 1], true, thisTriggers, thisPanels);
				} else if (pressed === keys.right || pressed === keys.down) {
					// Activate first tab
					ARIAtabs.activateTab(thisTriggers[0], true, thisTriggers, thisPanels);
				}
			}
		}
	}; // ARIAtabs.switchTabOnArrowPress

	/**
	 * Activate current tab and panel.
	 */
	ARIAtabs.activateTab = function (tab, setFocus, triggers, panels) {
		setFocus = setFocus || true;

		// Deactivate all other tabs
		ARIAtabs.deactivateTabs(triggers, panels);

		// Remove tabindex attribute
		tab.removeAttribute('tabindex');

		// Set the tab as selected
		tab.setAttribute('aria-selected', 'true');

		// Get the value of aria-controls (which is an ID)
		let controls = tab.getAttribute('aria-controls');

		// Remove hidden attribute from tab panel to make it visible
		doc.getElementById(controls).removeAttribute('hidden');

		// Set focus when required
		if (setFocus) {
			tab.focus();
		}
	}; // ARIAtabs.activateTab

	/**
	 * De-activate tabs and panels.
	 */
	ARIAtabs.deactivateTabs = function (triggers, panels) {
		let t;
		let p;

		for (t = 0; t < triggers.length; t++) {
			triggers[t].setAttribute('tabindex', '-1');
			triggers[t].setAttribute('aria-selected', 'false');
		}

		for (p = 0; p < panels.length; p++) {
			panels[p].setAttribute('hidden', 'hidden');
		}
	}; // ARIAtabs.deactivateTabs

	ARIAtabs.init = function () {
		ARIAtabs.create();
	};

	ARIAtabs.init();

})(window, document);
